import { pick } from 'lodash';
import cleanMetadataKeys from './cleanMetadataKeys';
import partitionKeys from './partitionKeys';

export default function metadataForNode(node) {
  if (node === true) { return {}; }

  const { metadata } = partitionKeys(node);

  return cleanMetadataKeys(pick(node, metadata));
}
